import { render, staticRenderFns } from "./checkedDes.vue?vue&type=template&id=471f752e&scoped=true"
import script from "./checkedDes.vue?vue&type=script&lang=js"
export * from "./checkedDes.vue?vue&type=script&lang=js"
import style0 from "./checkedDes.vue?vue&type=style&index=0&id=471f752e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f752e",
  null
  
)

export default component.exports